import { cva } from "class-variance-authority";

export const tabClasses = cva([], {
	variants: {
		variant: {
			default: "-mx-2 gap-4",
			"sub-table": "pt-4",
		},
	},
	defaultVariants: {
		variant: "default",
	},
});

export const tabListClasses = cva([], {
	variants: {
		variant: {
			default: "",
			"sub-table": "px-4",
		},
	},
	defaultVariants: {
		variant: "default",
	},
});
